import { render, staticRenderFns } from "./PxAutocompleteSegmento.vue?vue&type=template&id=8c6a95b0"
import script from "./PxAutocompleteSegmento.vue?vue&type=script&lang=js"
export * from "./PxAutocompleteSegmento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports